module.exports = "images/sport_motorsport.68b7c6b00747a0e98b5d41a68084a8c2.png";